export function stripToDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function isSameDay(date1: Date, date2: Date): boolean {
    if (date1 && date2) {
        return stripToDay(date1).getTime() === stripToDay(date2).getTime();
    } else {
        return !date1 && !date2;
    }
}

export function stripToWeek(date: Date): Date {
    const day = date.getDay();
    const firstDayInWeek = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.getFullYear(), date.getMonth(), firstDayInWeek);
}

export function stripToMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function stripToYear(date: Date): Date {
    return new Date(date.getFullYear(), 0, 1);
}

export function addYears(date: Date, years: number): Date {
    const d = new Date(date.getTime());
    d.setFullYear(date.getFullYear() + years);
    return d;
}

export function addMonths(date: Date, months: number, fromBegining?: boolean): Date {
    const d = new Date(date.getTime());
    if(fromBegining) {
        d.setMonth(date.getMonth() + months, 1);
    } else {
        d.setMonth(date.getMonth() + months);
    }
   
    return d;
}

export function addDays(date: Date, days: number): Date {
    const d = new Date(date.getTime());
    d.setDate(date.getDate() + days);
    return d;
}

export function addWeeks(date: Date, weeks: number): Date {
    return addDays(date, weeks * 7);
}

export function isDayDisabled(
    date: Date,
    minDate: Date,
    maxDate: Date,
    excludeDates: Date[],
    filterDate: (date: Date) => boolean
): boolean {
    const day = stripToDay(date);
    return (
        (minDate && stripToDay(minDate).getTime() > day.getTime()) || // day.isBefore(minDate, 'day')) ||
        (maxDate && stripToDay(maxDate).getTime() < day.getTime()) || // (maxDate && day.isAfter(maxDate, 'day')) ||
        (excludeDates && excludeDates.some((excludeDate) => isSameDay(day, excludeDate))) ||
        (filterDate && !filterDate(day)) ||
        false
    );
}

export function allDaysDisabledBefore(day: Date, minDate: Date): boolean {
    return minDate && day.getTime() < minDate.getTime();
}

export function allDaysDisabledAfter(day: Date, maxDate: Date): boolean {
    return maxDate && day.getTime() > maxDate.getTime();
}
